import React, { useState, useEffect, useContext } from 'react'
import { Formik } from 'formik'
import Paper from '@mui/material/Paper'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import { SwalContext } from 'genesis-suite/components'
import withStyles from '@mui/styles/withStyles';
import { User as UserIcon, Key as KeyIcon } from 'genesis-suite/icons'
import Loading from '../components/Loading'
import { authService, userService } from '../lib/services'
import FormWrapper from '../components/FormWrapper'
import { account, chgPassword } from '../lib/yupSchemas'
import { AccountForm, PasswordForm } from '../components/forms'
import { logEvent } from '../lib/amplitudeClient'

const styles = theme => ({
    paper: {
        display: 'flex',
        flexFlow: 'column wrap',
        maxWidth: 500,
        flexShrink: 2,
        position: 'relative',
        margin: '3rem auto 0 auto',
        padding: 12,
        '@media(max-height:750px)': {
            margin: '1rem auto 0 auto',
        },
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '1rem',
    },
    icon: {
        marginRight: 12,
    },
    divider: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
})

const Account = ({ classes, user: oidcUser }) => {
    const { userInfo } = oidcUser
    const [user, setUser] = useState()
    const { alert } = useContext(SwalContext)

    useEffect(() => {
        if (!user) {
            userService
                .getAccount()
                .then(user => setUser({ ...user.userInfo }))
                .catch(err => alert(err.Message || err.message, { type: 'error' }))
        }
    })

    if (!user) return <Loading title="Loading..." />

    const accountValues = {
        firstName: user.firstName,
        lastName: user.lastName,
        displayName: user.screenAlias,
        email: user.email,
        phone: user.phone,
    }

    const passwordValues = {
        password: '',
        newPassword: '',
        confirmPassword: '',
    }

    const submitAccountInfo = (data, { setSubmitting }) => {
        logEvent('Save Account Settings')
        const reqObj = {
            ...userInfo,
            FirstName: data.firstName,
            LastName: data.lastName,
            ScreenAlias: data.displayName,
            Email: data.email,
            Phone: data.phone,
        }
        userService
            .updateAccount(reqObj)
            .then(() => {
                setUser({ ...user, screenAlias: data.displayName })
                alert('Account Updated!', { type: 'success' })
            })
            .catch(err => alert(err.Message || err.message, { type: 'error' }))
            .finally(() => setSubmitting(false))
    }

    const submitPasswordChange = (data, { setSubmitting, resetForm }) => {
        logEvent('Update Password')
        const { password, newPassword } = data
        const { userId } = user
        const passwordChkReq = { UserId: userId, Password: password }
        authService
            .checkPassword(passwordChkReq)
            .then(() => {
                const reqObj = {
                    ...userInfo,
                    Password: newPassword,
                }
                userService
                    .updateAccount(reqObj)
                    .then(() => {
                        resetForm()
                        alert('Password changed!', { type: 'success' })
                    })
                    .catch(err => alert(err.Message || err.message, { type: 'error' }))
            })
            .catch(err => alert(err.Message || err.message, { type: 'error' }))
            .finally(() => setSubmitting(false))
    }

    return (
        <Paper elevation={1} className={classes.paper}>
            <div className={classes.header}>
                <UserIcon className={classes.icon} fontSize="large" />
                <Typography display="inline" variant="h5">
                    Account Settings
                </Typography>
            </div>
            <Formik
                render={props => <FormWrapper form={AccountForm} {...props} />}
                initialValues={accountValues}
                validationSchema={account}
                onSubmit={submitAccountInfo}
            />
            <Divider className={classes.divider} />
            <div className={classes.header}>
                <KeyIcon className={classes.icon} fontSize="large" />
                <Typography display="inline" variant="h5">
                    Change Password
                </Typography>
            </div>
            <Formik
                render={props => <FormWrapper form={PasswordForm} {...props} />}
                initialValues={passwordValues}
                validationSchema={chgPassword}
                onSubmit={submitPasswordChange}
            />
        </Paper>
    )
}

export default withStyles(styles)(Account)
